var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52067 5.0013C9.52067 5.2428 9.32467 5.4388 9.08317 5.4388H5.43734V9.08463C5.43734 9.32613 5.24134 9.52213 4.99984 9.52213C4.75834 9.52213 4.56234 9.32613 4.56234 9.08463V5.4388H0.916504C0.675004 5.4388 0.479004 5.2428 0.479004 5.0013C0.479004 4.7598 0.675004 4.5638 0.916504 4.5638H4.56234V0.917969C4.56234 0.676469 4.75834 0.480469 4.99984 0.480469C5.24134 0.480469 5.43734 0.676469 5.43734 0.917969V4.5638H9.08317C9.32467 4.5638 9.52067 4.7598 9.52067 5.0013Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.334c062ea5806d06793bee94f5034dc1.svg";
export { ForwardRef as ReactComponent };